import {

    MimaText,
    MimaButton,
    PageLoader,
    MimaTagInput,
    MimaTextArea,
} from '../../components';
import styles from '../../assets/styles/BulkSms/BulkSms.module.scss';
import React from 'react';
import { Formik } from 'formik';

const NewSms = ({
    closeComposeSide,
    tags,
    setTags,
    customers,
    vendors,
    SmsValidation,
    onSubmit,
    setBtnClicked,
    showScheduleMsgModal,
    selectAllCustomers,
    selectAllProspects,
    selectAllVendors,
    loading,
    removeAll,
}) => {

const searchContact = customers.concat(vendors);

const searchData = searchContact.map((x) => {
    return {
        a: x.fullname || x.name,
        mobile: x.mobile,
    }
})

    return (
        <div className={styles.compose}>
            {loading ? (<PageLoader />) : (
                <>
                    <div className={styles.compose__title}>
                        <MimaText variant="subtitleBold" mr={2} color="var(--color-primary)">
                            Create New Message
                        </MimaText>
                        <MimaButton title="X" variant="close" onClick={closeComposeSide} />
                    </div>

                    <Formik
                        initialValues={{
                            message: '',
                            mobile: [],
                        }}
                        validationSchema={SmsValidation()}
                        onSubmit={onSubmit}
                    >
                        {({
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            values,
                            errors,
                            touched,
                        }) => (
                            <div>
                                <div className={styles.compose__btns}>
                                    <MimaButton
                                        title="Add all Saved Customers"
                                        onClick={selectAllCustomers}
                                        variant="filter"
                                        width={25}
                                        buttonColor="var(--color-primary)"
                                    />
                                    <MimaButton
                                        title="Add all Prospects"
                                        onClick={selectAllProspects}
                                        variant="filter"
                                        width={25}
                                    />
                                    <MimaButton
                                        title="Add all Vendors"
                                        onClick={selectAllVendors}
                                        variant="filter"
                                        buttonColor="var(--color-green)"
                                        width={25}
                                    />
                                    <MimaButton
                                        title="Remove Selected Contacts"
                                        onClick={removeAll}
                                        variant="filter"
                                        buttonColor="var(--color-error)"
                                        width={25}
                                    />
                                </div>
                                <MimaTagInput
                                    placeholder='Enter Contact name or Phone number'
                                    labelTitle="Contact Name or Phone number"
                                    suggestionData={searchData}
                                    handleFilter={(item, text) => {
                                        return (
                                            item?.a?.toLowerCase()?.includes(text) ||
                                            item?.b?.toLowerCase()?.includes(text) ||
                                            item?.mobile?.toLowerCase()?.includes(text)
                                        )
                                    }}
                                    tags={tags}
                                    setTags={setTags}
                                    name="mobile"
                                    // value={values.mobile}
                                    onBlur={handleBlur}
                                    error={errors.mobile}
                                    touched={touched.mobile}
                                />
                                <MimaTextArea
                                    placeholder='Enter Message to send'
                                    labelTitle="Message Content"
                                    textAreaVariant="type2"
                                    name="message"
                                    value={values.message}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.message}
                                    touched={touched.message}
                                    showPageCount
                                />

                                <div className={styles.compose__btns}>
                                    <MimaButton
                                        variant="outlined"
                                        title="Schedule Message"
                                        onClick={() => {
                                            handleSubmit();
                                            setBtnClicked("scheduleMessage");
                                            showScheduleMsgModal()
                                        }}
                                    />

                                    <MimaButton
                                        title="Save as Draft"
                                        buttonColor="var(--color-dark)"
                                        width={18}
                                        type="submit"
                                        onClick={() => {
                                            handleSubmit();
                                            setBtnClicked("saveDraft");
                                        }}
                                    />
                                    <MimaButton
                                        title="Send Message"
                                        width={18}
                                        type="submit"
                                        onClick={() => {
                                            handleSubmit();
                                            setBtnClicked("send");
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </Formik>
                </>
            )}
        </div>
    )
}

export default NewSms